export default __webpack_public_path__ + "static/media/bell-enabled.ad887d5b.svg";